import '../../App.css'
import { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid'
import { SelectGenericFromTable } from '../universal/Axios';
import { GetPerformancePercentile } from '../universal/InternalCalculator';
import Button from '@mui/material/Button'
import ArrowForward from '@mui/icons-material/ArrowForward';
import { CustomToolbar } from '../universal/GridHelper';


const ComparativeSetResultsTable = ({ id, selectedDensityNetworkConfigIDs, selectDensityNetworkConfigID }) => {
    //const comparativeSetResultsData = store.comparativeSetResultses
    const [comparativeSetResultsData, setComparativeSetResultsData] = useState([]);

    useEffect(() => {
        SelectGenericFromTable("select * from comparative_set_density_network_config_pair where comparative_set_id = '" + id + "';", setComparativeSetResultsData)
    }, []);


    if (comparativeSetResultsData === undefined) {
        return (<p>loading...</p>)
    }

    const comparativeSetResultsColumns = [
        {
            field: 'actions',
            headerName: 'Actions',
            width: 70,
            renderCell: (params) => (
                <>
                    {
                        <Button
                            href="#"

                            //replace with V
                            //onClick={() => syncComparativeSetResults(params.row.id)}
                        >
                            <ArrowForward />
                        </Button>
                    }
                </>
            ),
        },
        {
            field: 'id',
            headerName: 'Density Network Config ID',
            width: 840,
            renderCell: (params) => (
                <>
                    <a
                        href={'edit-density-network-config?id=' + params.row.id}
                    >
                        {params.row.id}
                    </a>
                </>
            ),
        },
        {
            field: 'n',
            headerName: 'N',
            width: 180,
        },
        {
            field: 'mean_si_sdr',
            headerName: 'Average SI-SDR',
            width: 140,
            renderCell: (params) => (
                params.value != null ?
                    <span style={{ color: 'rgb(' + ((1 - parseFloat(params.row.relative_average_si_sdr)) * 255) + ',' + (parseFloat(params.row.relative_average_si_sdr) * 255) + ',0)' }}
                    >
                        {params.value.toString()}
                    </span> : <span></span>
            ),
        },
        {
            field: 'median_si_sdr',
            headerName: 'Median SI-SDR',
            width: 140,
            renderCell: (params) => (
                params.value != null ?
                    <span style={{ color: 'rgb(' + ((1 - parseFloat(params.row.relative_median_si_sdr)) * 255) + ',' + (parseFloat(params.row.relative_median_si_sdr) * 255) + ',0)' }}
                    >
                        {params.value.toString()}
                    </span> : <span></span>
            ),
        },
        {
            field: 'last_updated',
            headerName: 'Last Updated',
            width: 140
        }
    ];

    let comparativeSetResultsDataRows = comparativeSetResultsData?.filter(data => data != null).map((comparativeSetResults) =>
    ({   
        id: comparativeSetResults.density_network_config_id,
        n: comparativeSetResults.n,
        mean_si_sdr: comparativeSetResults.mean_si_sdr,
        median_si_sdr: comparativeSetResults.median_si_sdr,
        last_updated: comparativeSetResults.last_updated,
    }))

    comparativeSetResultsDataRows = GetPerformancePercentile(comparativeSetResultsDataRows, 'mean_si_sdr', 'relative_average_si_sdr', 0);
    comparativeSetResultsDataRows = GetPerformancePercentile(comparativeSetResultsDataRows, 'median_si_sdr', 'relative_median_si_sdr', 0);

    return (
        <DataGrid
            disableSelectionOnClick
            rows={comparativeSetResultsDataRows}
            columns={comparativeSetResultsColumns}
            pagination={true}
            initialState={{
              sorting: {
                    sortModel: [{ field: 'created_date', sort: 'desc' }, { field: 'id', sort: 'desc'}],
              },
            }}
            selectionModel={selectedDensityNetworkConfigIDs}
            onSelectionModelChange={(densityNetworkConfig) => {
                selectDensityNetworkConfigID(densityNetworkConfig)
            }}
            checkboxSelection
            components={{
                Toolbar: () => CustomToolbar("Comparative_Set_" + id + "_Results")
            }}
      />
    )
};

export { ComparativeSetResultsTable };
